"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Card(props) {
  let {
    style,
    ...cardProps
  } = props;
  let inlineStyles = {
    shadowColor: "#777",
    shadowOffset: {
      width: 0,
      height: 4
    },
    shadowOpacity: 0.32,
    shadowRadius: 5.46,
    elevation: 6
  };

  if (style) {
    inlineStyles = { ...inlineStyles,
      ...style
    };
  }

  return /*#__PURE__*/_react.default.createElement(_Box.default, _extends({
    style: inlineStyles,
    br: "m",
    bg: "common.white"
  }, cardProps), props.children);
}

var _default = Card;
exports.default = _default;